module.exports = __webpack_public_path__ + "static/media/Seco-Cinza.a8078b3b.svg";